import {Modal, Text} from "@mantine/core";
import {Trans, useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {openIntercom} from "../chat/utils";
import {ChecklistModalActions} from "./checklist/ChecklistModalActions";
import classes from "./checklist/modalStyles.module.css";

/**
 * Blocking overlay for topics the user's subscription doesn't cover
 * (AccessContext gate). Mirrors DibApp2020's no-access dialog: the content
 * stays rendered underneath, and the modal offers no dismissal besides
 * navigating away — closing it client-side only exposes content the backend
 * already shipped, which is accepted.
 */
export const NoAccessModal = ({opened}: {opened: boolean}) => {
    const {t} = useTranslation();
    const navigate = useNavigate();

    return (
        <Modal
            opened={opened}
            onClose={() => {}}
            title={t("Phrase.NoAccess")}
            size="32rem"
            radius="sm"
            withCloseButton={false}
            closeOnEscape={false}
            closeOnClickOutside={false}
            classNames={{
                title: classes.modalTitle,
                content: classes.modalContent,
            }}
        >
            <Text className={classes.modalText}>
                <Trans
                    i18nKey="Phrase.SorryYouDoNotHaveAccessToContent"
                    components={{"strong-1": <strong />}}
                />
            </Text>
            <Text className={classes.modalText} mt="sm">
                <Trans
                    i18nKey="Phrase.ContactUsForUpgrade"
                    defaults="<a-1>Please contact us</a-1> to upgrade your access."
                    components={{
                        "a-1": (
                            <a
                                href="#"
                                onClick={(e) => {
                                    e.preventDefault();
                                    openIntercom();
                                }}
                            />
                        ),
                    }}
                />
            </Text>
            <ChecklistModalActions
                primary={{
                    label: t("Phrase.GoBack", {defaultValue: "Go back"}),
                    onClick: () => navigate(-1),
                }}
            />
        </Modal>
    );
};
